import React, { Component } from 'react';
import localStore from 'store';

class LogoutError extends Component {
  componentDidMount() {
    const jwt = localStore.get('jwt');
    if (!jwt) {
      localStore.remove('authorizationCode');
      localStore.remove('userId');
      window.location = window.location.origin;
    }
  }

  render() {
    const jwt = localStore.get('jwt');
    if (!jwt) {
      return null;
    }
    return (
      <div>
        <p>Log out was unsuccessful.</p>
      </div>
    );
  }
}

export default LogoutError;
